import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowsClockwiseIcon } from "@phosphor-icons/react";

export default function AIDescriptionButton({ form, onGenerated }) {
  const [loading, setLoading] = useState(false);
  const [tone, setTone] = useState("professional");

  const generate = async () => {
    if (!form.brand || !form.model || !form.year) {
      toast.error("Συμπληρώστε πρώτα μάρκα, μοντέλο και έτος");
      return;
    }
    setLoading(true);
    try {
      const r = await api.post("/ai/generate-description", {
        brand: form.brand,
        model: form.model,
        variant: form.variant || "",
        year: Number(form.year) || 0,
        mileage_km: Number(form.mileage_km) || 0,
        fuel_type: form.fuel_type,
        transmission: form.transmission,
        body_type: form.body_type,
        engine_cc: Number(form.engine_cc) || 0,
        horsepower: Number(form.horsepower) || 0,
        color_exterior: form.color_exterior || "",
        color_interior: form.color_interior || "",
        equipment: form.equipment || [],
        price_eur: Number(form.price_eur) || 0,
        tone,
        must_include: form.description_must_include || "",
      });
      onGenerated(r.data);
      const extras = [];
      if (r.data.excerpt) extras.push("excerpt");
      if (r.data.seo_title) extras.push("SEO title");
      if (r.data.seo_description) extras.push("SEO description");
      toast.success(
        extras.length
          ? `Δημιουργήθηκαν: περιγραφή + ${extras.join(", ")}`
          : "Η περιγραφή δημιουργήθηκε"
      );
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Αποτυχία AI");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col md:flex-row md:items-center gap-2 mb-3 p-3 bg-[#0A0A0A] text-white">
      <div className="flex-1" />
      <select
        value={tone}
        onChange={(e) => setTone(e.target.value)}
        data-testid="ai-tone-select"
        className="bg-white/10 text-white text-xs px-2 py-1.5 outline-none border border-white/20"
      >
        <option value="professional" className="text-black">Επαγγελματικό</option>
        <option value="friendly" className="text-black">Φιλικό</option>
        <option value="premium" className="text-black">Πολυτελές</option>
      </select>
      <button
        type="button"
        onClick={generate}
        disabled={loading}
        data-testid="ai-generate-btn"
        className="bg-[#374151] hover:bg-[#1F2937] text-white text-xs px-3 py-1.5 flex items-center gap-1.5 disabled:opacity-50"
      >
        {loading ? <ArrowsClockwiseIcon size={14} className="animate-spin" /> : null}
        {loading ? "Δημιουργία..." : "Seo περιγραφή"}
      </button>
    </div>
  );
}
